import { useQuery } from '@tanstack/react-query'
import api from '../utils/api'

export const useJobResults = (jobId, enabled = true) => {
  return useQuery({
    queryKey: ['job-results', jobId],
    queryFn: async () => {
      if (!jobId) {
        throw new Error('Job ID is required')
      }
      
      try {
        const response = await api.get(`/user/jobs/${jobId}/results`)
        return response.data
      } catch (error) {
        // Fallback to legacy single-file format
        if (error.response?.status === 404) {
          console.log('Enhanced results endpoint not available, falling back to legacy format')
          const legacyResponse = await api.get(`/user/jobs/${jobId}`)
          const jobData = legacyResponse.data
          
          // Convert legacy format to new format
          if (jobData.download_url && jobData.status === 'completed') {
            return {
              job_id: jobData.job_id,
              status: jobData.status,
              created_at: jobData.created_at,
              completed_at: jobData.updated_at,
              output_files: [{
                filename: 'translation.csv', // Default filename for legacy
                file_type: 'csv',
                language_code: null,
                size_bytes: null,
                download_url: jobData.download_url,
                expires_at: new Date(Date.now() + 3600000).toISOString(), // 1 hour from now
                metadata: null
              }],
              archive_options: null // Single file, no archive needed
            }
          }
        }
        throw error
      }
    },
    enabled: enabled && !!jobId,
    staleTime: 30000, // 30 seconds
    refetchInterval: (data) => {
      // Only refetch if status is not completed
      return data?.status !== 'completed' ? 5000 : false
    }
  })
}

export const useArchiveGeneration = () => {
  return {
    generateArchive: async (jobId) => {
      const response = await api.post(`/user/jobs/${jobId}/archive/generate`)
      return response.data
    },
    
    checkArchiveStatus: async (jobId, taskId) => {
      const response = await api.get(`/user/jobs/${jobId}/archive/status/${taskId}`)
      return response.data
    }
  }
}